/**
 * Combines the folders of the media service (HCIT-1105) and of the Image Service ("legacy", the
 * archive). Media folders are the normal result; archive folders follow and are marked `archive`, so
 * images that are missing in the media service show up as folders only the archive has. A folder keeps
 * the service that holds it (and its id there) in `sources`, so its images can be loaded from it.
 */
export const LEGACY = "legacy";
export const MEDIA = "media";

/** Appended to the label of archive folders. */
export const ARCHIVE_SUFFIX = " - ARCHIV";

/**
 * @param legacyFolders folders of the Image Service, or null if that request failed
 * @param mediaFolders  folders of the media service, or null likewise
 * @returns the media folders, then the archive folders (also those with the same name)
 */
export function combineFolders (legacyFolders, mediaFolders) {
    const media = (mediaFolders || []).map(folder => ({
        ...folder, archive: false, sources: [{ source: MEDIA, id: folder.id }]
    }));
    const archive = (legacyFolders || []).map(folder => ({
        ...folder, archive: true, sources: [{ source: LEGACY, id: folder.id }]
    }));
    return [...media, ...archive];
}

/** Tags each image with the service it came from. */
export function tagImages (images, source) {
    return (images || []).map(image => ({ ...image, source }));
}
